import { render, staticRenderFns } from "./ShortBiographyProfile.vue?vue&type=template&id=6f7155eb&"
import script from "./ShortBiographyProfile.vue?vue&type=script&lang=js&"
export * from "./ShortBiographyProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports